import { useMutation } from "react-query";
import { axiosPost } from "../../lib/axiosClient";

const useCreateSelfTest = () => {
  return useMutation((newTest) => {
    return axiosPost("/api/cw/createSelfTest", newTest);
  });
};

export default useCreateSelfTest;
